import { configureStore } from '@reduxjs/toolkit'
import { createReducerManager } from './reducerManager'
import { userReducer } from '../../entity/user/model/slice/userSlice'
import { currentIssueReducer } from '../../entity/current-issue/CurrentIssue'
import { volumesReducer } from '../../entity/volumes/Volumes'
import { aboutReducer } from '../../entity/about/About'
import { aboutSectionReducer } from '../../entity/about-sections/AboutSection'
import { guideReducer } from '../../entity/guide/Guide'

export function createReduxStore(initialState) {
  const rootReducer = {
    user: userReducer,
    currentIssue: currentIssueReducer,
    volumes: volumesReducer,
    about: aboutReducer,
    aboutSections: aboutSectionReducer,
    guide: guideReducer,
  }

  const reducerManager = createReducerManager(rootReducer)

  const store = configureStore({
    reducer: reducerManager.reduce,
    preloadedState: initialState,
  })

  store.reducerManager = reducerManager

  return store
}

export const AppDispatch = createReduxStore().dispatch
